import { RootState } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** State specific for creating location marker */
type LocationMarkerState = {
  /**
   * true to enable location marker creation
   */
  isLocationMarkerCreationEnabled: boolean;

  /**
   * ID of area where location marker will be created
   */
  areaId: GUID;
};

const initialState: LocationMarkerState = {
  isLocationMarkerCreationEnabled: false,
  areaId: "",
};

const locationMarkerSlice = createSlice({
  initialState,
  name: "locationMarker",
  reducers: {
    enableLocationMarkerCreation(state, action: PayloadAction<boolean>) {
      state.isLocationMarkerCreationEnabled = action.payload;
    },
    setLocationMarkerArea(state, action: PayloadAction<GUID>) {
      state.areaId = action.payload;
    },
  },
});

export const { enableLocationMarkerCreation, setLocationMarkerArea } =
  locationMarkerSlice.actions;

export const locationMarkerReducer = locationMarkerSlice.reducer;

/**
 * @returns if location marker creation is enabled
 */
export function selectIsLocationMarkerCreationEnabled({
  locationMarker,
}: RootState): boolean {
  return locationMarker.isLocationMarkerCreationEnabled;
}

/**
 * @returns area ID for new location markers
 */
export function selectLocationMarkerArea({ locationMarker }: RootState): GUID {
  return locationMarker.areaId;
}
